module.exports = __webpack_public_path__ + "img/payment_successful.6b8f8369.gif";